<template>
	<div v-if="show" class="right-menu-mask" @click.stop="close()" @contextmenu.prevent="close()">
		<div ref="menu" class="right-menu" :style="{ 'left': pos.x + 'px', 'top': pos.y + 'px' }">
			<el-menu text-color="#333333">
				<el-menu-item v-for="(item) in items" :key="item.key" :title="item.name"
					@click.native.stop="onSelectMenu(item)">
					<i v-if="item.icon" :class="[item.icon, 'right-menu-item-icon']"></i>
					<span class="right-menu-item-name">{{ item.name }}</span>
				</el-menu-item>
			</el-menu>
		</div>
	</div>
</template>

<script>
export default {
	name: "rightMenu",
	data() {
		return {
			show: false,
			pos: {
				x: 0,
				y: 0,
			},
			items: []
		}
	},
	methods: {
		open(pos, items) {
			this.pos = pos;
			this.items = items;
			this.show = true;
			this.$nextTick(() => this.adjustPosition());
		},
		adjustPosition() {
			const menu = this.$refs.menu;
			if (!menu) return;
			const padding = 8;
			const menuWidth = menu.offsetWidth || 0;
			const menuHeight = menu.offsetHeight || 0;
			const maxX = window.innerWidth - menuWidth - padding;
			const maxY = window.innerHeight - menuHeight - padding;
			const safeX = Math.min(Math.max(this.pos.x, padding), Math.max(maxX, padding));
			const safeY = Math.min(Math.max(this.pos.y, padding), Math.max(maxY, padding));
			this.pos = { x: safeX, y: safeY };
		},
		close() {
			this.show = false;
		},
		onSelectMenu(item) {
			this.$emit("select", item);
			this.close();
		}
	}
}
</script>

<style lang="scss">
.right-menu-mask {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	z-index: 9999;
}

.right-menu {
	position: fixed;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: var(--im-box-shadow-light);

	.el-menu {
		border-radius: 4px;
		overflow: hidden;

		.el-menu-item {
			display: flex;
			align-items: center;
			height: 36px;
			line-height: 36px;
			min-width: 120px;
			padding: 0 14px !important;
			text-align: left;

			.right-menu-item-icon {
				margin-right: 8px;
				font-size: 14px;
				color: var(--im-color-primary, #092f80);
			}

			.right-menu-item-name {
				flex: 1;
			}

			&:hover {
				background-color: var(--im-background-active);
			}
		}
	}
}
</style>
